import React from 'react';
import DesktopBrowseBottom728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopBrowseBottom728x90';
import UserDesktopBrowseBottom728x90 from '@wix/da-ads/pkg/adunits/user/DesktopBrowseBottom728x90';
import { useSelector } from 'react-redux';
import {
  getCurrentAdSafety,
  getSafetyState,
} from '@wix/da-shared-react/pkg/Ads/redux/selectors';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';

import s from './BottomAd.scss';

interface Props {}

const BottomAd: React.FC<Props> = () => {
  const adSafety = useSelector(state => getCurrentAdSafety(state));
  const adSafetyState = useSelector(state => getSafetyState(state));
  return (
    <div className={s['root']}>
      <AnonOrUserUnit
        anon={DesktopBrowseBottom728x90}
        user={UserDesktopBrowseBottom728x90}
        safety={adSafety ?? 'off'}
        safetyState={adSafetyState}
      />
    </div>
  );
};
BottomAd.displayName = 'BottomAd';

export default BottomAd;
